import { post, get } from '@/utils/request/mAxios';
import APIs from './index';
import axios from 'axios';
import { TeamListQuery, OpensceneQuery } from '@/typings/common';

/* eslint-disable @typescript-eslint/camelcase */
const reportData = {
  identify_key: '90d1d5d591d1ea3a999acc0f969ecb8c73fa4e9af024330a28c081fdc247a888', // 必传
  board_id: 1694916504209416, // 版块ID，必传
  form_id: 1694916337364995, // 表单ID，必传
  title: '工单标题', // required
  type: 'guest', // required 'redirect | guest' 访客模式或者重定向模式
  guest_mode: {
    is_finish: false, // required 具体意义请人工咨询
    lang: 'EN', // required
    guest_email: 'email@b.com', // required
  }, // 访客模式下必填
  lang: 'ZH', // required 跳转雅典娜工单创建界面的语言参数
  category_1: '错误反馈',
  /**
   * NOTE: 即使你在表单里设置了某项为非必填
   * 在创建工单时仍须要将此项列出来，content 为空值或者空数组
   * 不然会报 invalid_type 错误
   */
  order_data: {
    items: [],
  }, // required
};

// export function reportAthenaForm(data: any, config: any) {
//   reportData.order_data.items = data;
//   return axios({
//     method: 'post',
//     url: APIs.reportAthenaForm,
//     headers: {
//       'athena-dock-token': '1f319c204d2229f7675fdba15e2032ed',
//     },
//     data: {
//       ...reportData,
//       identify_key: config.identifyKey,
//       board_id: config.boardId,
//       form_id: config.formId,
//     },
//   });
// }

export function getOpenSceneList(data: OpensceneQuery = {}) {
  return get(APIs.getOpenSceneList, data);
}

export function getTeamList(params: TeamListQuery) {
  return get(APIs.getTeamList, params);
}

// 图片上传
export function uploadFile(data: any, config: any = {}) {
  return axios({
    method: 'post',
    url: APIs.uploadImage,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
    ...config,
  });
}
